import React, { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Image, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import IMAGES from "constants/images";
import { getMyReviewList } from "api/ActivityService"; // make sure this exists
import { deleteReview } from "api/ReviewService";
import { toast } from "react-toastify"; // for notification
import { useNavigate } from "react-router-dom";
import ReactShowMoreText from "react-show-more-text";
import RatingStars from "components/RatingStars";
import { Sentry } from "react-activity";
import CommonModal from "components/CommonModal";
import Loader from "components/Loader";

const sortOptions = [
  { label: "Most Recent", value: "most_recent" },
  { label: "Highest", value: "highest_rating" },
  { label: "Lowest", value: "lowest_rating" },
];

const SortDropdown = ({ selectedOption, setSelectedOption }) => {
  return (
    <Dropdown align="start">
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center rounded-pill px-3"
      >
        <Icon icon="solar:sort-linear" fontSize={19} className="me-2" />
        <span className="iconFull">{selectedOption.label}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {sortOptions.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => setSelectedOption(option)}>
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default function MyReviews({ userId }) {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(sortOptions[0] || []);
  const [pageLoading, setPageLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const fetchReviews = async (pageNum = 1) => {
    setLoading(true);
    try {
      const filter = selectedOption.value;
      const res = await getMyReviewList(filter, userId, pageNum, 3); // API call
      if (res.success) {
        const newReviews = res.body.data.map((review) => ({
          id: review._id,
          productData: review.productId,
          product: review.productId?.name || "Unknown",
          logo: review.productId?.logoUrl || IMAGES.Logo1,
          brandColors: review.productId?.brandColors || "#F0F0F0",
          rating: parseFloat(review.overallRating),
          title: review.title,
          date: new Date(review.createdAt).toLocaleDateString(),
          description: review.review,
        }));
        setReviews((prev) =>
          pageNum === 1 ? newReviews : [...prev, ...newReviews]
        );
        setTotalPages(res.body.total_pages);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setLoading(false);
      setPageLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!showDeleteModal) {
      return true;
    }

    try {
      setSubmitLoader(true);
      const res = await deleteReview({ reviewId: showDeleteModal });
      if (res.success) {
        toast.success("Review deleted successfully");
        fetchReviews(1);
        setShowDeleteModal(false);
      } else {
        toast.error("Failed to delete review");
      }
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);
      toast.error("An error occurred while deleting the review");
      console.error("Delete Review Error:", err);
    }
  };

  useEffect(() => {
    fetchReviews(1);
  }, [selectedOption]);

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchReviews(nextPage);
  };

  return pageLoading ? (
    <div className="loaderdiv">
      <Sentry color="#e91515" size={40} speed={1} animating={true} />
      {/* <Loader  style={{width: 100, height: 100}} /> */}
    </div>
  ) : (
    <>
      <div className="tab_1_style">
      <div className="profile_details_style header_profile3 mb-4">
        {/* <Icon icon="mdi:arrow-left" className="me-2" onClick={() => navigate("/")}/> */}
        <h2>My Reviews</h2>
        <SortDropdown
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
      </div>
      <div className="d-flex align-items-center justify-content-between header_profile2 mb-3 ">
      <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/my-profile")}/>
      <h3 className="mb-0">My Reviews</h3>
      </div>
        <SortDropdown
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
      </div>
    

        {reviews?.map((review) => (
          <div className="r_Card mb-4" key={review.id}>
            <div className="headerFLex  headerFLex1 mb-4">
              <div
                className="iconBox "
                style={{
                  backgroundColor: review.brandColors,
                  cursor: "pointer",
                  border: "2px solid #FFFFFF",
                }}
                onClick={() => {
                  navigate(`/product-details/${review.productData.slug}`, {
                    state: { productId: review.productData },
                  });
                }}
              >
                <Image
                  src={review.logo}
                  alt={review.product}
                  style={{ width: 40, height: 40, objectFit: "contain" }}
                />
              </div>
              <div
                className=" added_margin_top added_width   show_laptop flex-column"
                style={{ width: "100%" }}
              >
                <h4
                  className="truncate-2-lines"
                  style={{ cursor: "pointer",    wordWrap: "break-word" }}
                  onClick={() => {
                    navigate(`/product-details/${review.productData.slug}`, {
                      state: { productId: review.productData },
                    });
                  }}
                >
                  {`${review.product}`}
                </h4>
                <p className="date_para mb-0 d-flex align-items-center ">
                  <RatingStars rating={review?.productData?.avgRating} />
                  <div
                    className="total_review_text"
                    style={{ marginLeft: "4px" }}
                  >
                    ({review?.productData?.totalReviews})
                  </div>
                </p>
              </div>
              <div className="d-flex gap-2">
              <Button
                variant="info"
                className="border-radius-100 ms-auto hAnswers d-flex align-items-center"
                onClick={() => {
                  navigate("/write-a-review", {
                    state: { reviewId: review.id },
                  });
                  const updatedChecked = [review.productData];

                  localStorage.setItem(
                    "checkedProducts",
                    JSON.stringify(updatedChecked)
                  );
                  localStorage.setItem("step", 3);
                }}
              >
                <Icon icon="lucide:edit" fontSize={16}  />
                <span className="header_profile1 ms-2">Edit Review</span>
              </Button>
              <Button
                variant="danger"
                className="border-radius-100 hAnswers d-flex align-items-center"
                onClick={() => setShowDeleteModal(review.id)}
              >
                <Icon icon="mi:delete" fontSize={17}  />
                <span className="header_profile1 ms-2">Delete Review</span>
              </Button>
              </div>
            </div>
            <div
                className=" added_margin_top added_width show_mobile show_tab flex-column mb-4"
                style={{ width: "100%" }}
              >
                <h4
                  className="truncate-2-lines"
                  style={{ cursor: "pointer",    wordWrap: "break-word" }}
                  onClick={() => {
                    navigate(`/product-details/${review.productData.slug}`, {
                      state: { productId: review.productData },
                    });
                  }}
                >
                  {`${review.product}`}
                </h4>
                <p className="date_para mb-0 d-flex align-items-center ">
                  <RatingStars rating={review?.productData?.avgRating} />
                  <div
                    className="total_review_text"
                    style={{ marginLeft: "4px" }}
                  >
                    ({review?.productData?.totalReviews})
                  </div>
                </p>
              </div>
            <h4 style={{ wordWrap: "break-word" }}>{`“${review.title}”`}</h4>
            <p className="date_para mb-2">
              <RatingStars rating={review.rating} />
              <span className="ms-1">{review.date}</span>
            </p>
            <Card className="mb-0 border-0 pb-0">
              <Card.Body className="mb-0 ">
                <ReactShowMoreText
                  lines={2}
                  more="See more"
                  less="See less"
                  anchorClass="see-more-link"
                  expanded={false}
                  width={0}
                >
                  {review.description}
                </ReactShowMoreText>
              </Card.Body>
            </Card>
          </div>
        ))}

        {page < totalPages && (
          <div className="text-center mt-3  d-flex justify-content-center">
            <Button
              variant="outline-primary"
              onClick={loadMore}
              disabled={loading}
              style={{
                width: "351px",
                borderRadius: "50px",
                borderColor: "#0071E3",
                color: "#0071E3",
              }}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "More Reviews"
              )}
            </Button>
          </div>
        )}

        {!loading && reviews.length === 0 && (
          <Col xs={12}>
            <div className="text-center py-5">
              <Image
                src={IMAGES.emptyState}
                alt=""
                height="300px"
                width="300px"
                className="mb-4"
                // className="imgUser"
              />
              <p className="text-center text-muted">No reviews found.</p>
            </div>
          </Col>
        )}
      </div>
      <CommonModal
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(null);
        }}
        title="Confirm Deletion"
        para="Are you sure you want to delete this review? This action cannot be undone."
        body={
          <div className="d-flex justify-content-center gap-2 mt-3">
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeleteModal(null);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={submitLoader}
              variant="danger"
              style={{ width: submitLoader && "85px" }}
              onClick={() => {
                handleDelete();
              }}
            >
              {submitLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        }
      />
    </>
  );
}
